import { render, staticRenderFns } from "./RescindContract.vue?vue&type=template&id=0c240d3f&scoped=true"
import script from "./RescindContract.vue?vue&type=script&lang=js"
export * from "./RescindContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c240d3f",
  null
  
)

export default component.exports